<template>

    <m-edit1/>

    <m-single-product-511 v-bind='{...{"productLink":null,"product":null,"useNativePrice":false,"showVariationProductImage":true,"variationProductComponent":"variation-product","showVariationTable":true,"showWallpaper":true,"wallpaper":null,"wallpaperOpacity":1,"background":null,"backgroundColor":"#fff","theme":"light","relatedProducts":true,"productCardName":"mProductCard525","productCardLink":false,"showKeywords":false,"offerStatus":true,"relatedSlideWidth":260,"trustItems":[{"title":"\u0636\u0645\u0627\u0646\u062a \u0627\u0635\u0627\u0644\u062a \u06a9\u0627\u0644\u0627","sub":"\u0628\u0647\u062a\u0631\u06cc\u0646 \u0645\u0648\u0627\u062f \u0627\u0648\u0644\u06cc\u0647","icon":"bi bi-shield-check"},{"title":"\u0627\u0631\u0633\u0627\u0644 \u0633\u0631\u06cc\u0639","sub":"\u062a\u062d\u0648\u06cc\u0644 \u062f\u0631 \u06a9\u0648\u062a\u0627\u0647\u200c\u062a\u0631\u06cc\u0646 \u0632\u0645\u0627\u0646","icon":"bi bi-truck"},{"title":"\u06f7 \u0631\u0648\u0632 \u0636\u0645\u0627\u0646\u062a \u0628\u0627\u0632\u06af\u0634\u062a","sub":"\u062e\u0631\u06cc\u062f \u0645\u0637\u0645\u0626\u0646 \u0628\u062f\u0648\u0646 \u0631\u06cc\u0633\u06a9","icon":"bi bi-arrow-counterclockwise"},{"title":"\u067e\u0634\u062a\u06cc\u0628\u0627\u0646\u06cc \u062a\u062e\u0635\u0635\u06cc","sub":"\u0645\u0634\u0627\u0648\u0631\u0647 \u0627\u0646\u062a\u062e\u0627\u0628 ","icon":"bi bi-headset"}]},...{}}' :style='""' class="" ></m-single-product-511>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct511 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct511';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct511 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
